module.exports = __webpack_public_path__ + "static/media/bg-1-features.52d51a46.svg";